import i18n from "@/libs/i18n/i18n";
import educationalDegrees from "@/constatnts/educationalDegrees";
export const initialState = {
  
};
